import {
  CONTRACT, D3_IS_NOT_SUPPORTED,
  HDR_IS_NOT_SUPPORTED, NO_DRM_SUPPORT,
  NO_VOD_COUNTRY,
  NOT_ENABLED_IN_COUNTRY,
  UHD_IS_NOT_SUPPORTED,
} from './constants';
import { ERROR_TYPE } from '../containers/ErrorPage/errorTypes';

export default new Map([
  [NO_VOD_COUNTRY, ERROR_TYPE.GEO],
  [NOT_ENABLED_IN_COUNTRY, ERROR_TYPE.GEO],
  [CONTRACT, ERROR_TYPE.LICENSE],
  [NO_DRM_SUPPORT, ERROR_TYPE.DRM],
  [HDR_IS_NOT_SUPPORTED, ERROR_TYPE.DEVICE],
  [UHD_IS_NOT_SUPPORTED, ERROR_TYPE.DEVICE],
  [D3_IS_NOT_SUPPORTED, ERROR_TYPE.DEVICE],
]);
